// Convert Bible verse references in text into links to Bible Gateway.
// Handles books like "John 3:16", "1 Peter 5:7", "Romans 10:9-13", "2 Corinthians 9:7".

const BOOKS = [
  "Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy",
  "Joshua", "Judges", "Ruth", "1 Samuel", "2 Samuel",
  "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles",
  "Ezra", "Nehemiah", "Esther", "Job", "Psalm", "Psalms",
  "Proverbs", "Ecclesiastes", "Song of Solomon", "Song of Songs",
  "Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel",
  "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah",
  "Nahum", "Habakkuk", "Zephaniah", "Haggai", "Zechariah", "Malachi",
  "Matthew", "Mark", "Luke", "John", "Acts", "Romans",
  "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians",
  "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians",
  "1 Timothy", "2 Timothy", "Titus", "Philemon", "Hebrews", "James",
  "1 Peter", "2 Peter", "1 John", "2 John", "3 John", "Jude", "Revelation",
];

// Sort by length desc so multi-word matches win first ("Song of Solomon" > "Song").
const SORTED_BOOKS = [...BOOKS].sort((a, b) => b.length - a.length);
const ESC = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const BOOK_PATTERN = SORTED_BOOKS.map(ESC).join("|");
// e.g. "John 3:16" or "Romans 10:9-13" or "Psalm 23"
const REF_REGEX = new RegExp(
  `\\b(${BOOK_PATTERN})\\s+(\\d{1,3})(?::(\\d{1,3}(?:-\\d{1,3})?))?\\b`,
  "g"
);

function bgUrl(ref) {
  return `https://www.biblegateway.com/passage/?search=${encodeURIComponent(ref)}&version=KJV`;
}

// Replace verse references in a plain-text string with anchor HTML.
export function linkifyText(text) {
  if (!text) return "";
  return String(text).replace(REF_REGEX, (match, book, ch, vs) => {
    const ref = vs ? `${book} ${ch}:${vs}` : `${book} ${ch}`;
    return `<a href="${bgUrl(ref)}" target="_blank" rel="noreferrer" class="bg-verse-link" data-testid="bible-verse-link">${ref}</a>`;
  });
}

// Linkify verse references inside an HTML string WITHOUT breaking existing tags.
// Walks the text nodes only. Uses a DOM parser at runtime.
export function linkifyHtml(html) {
  if (!html) return "";
  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return linkifyText(html);
  }
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const root = doc.body.firstChild;
  const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.parentElement && node.parentElement.closest("a")) continue;
    if (REF_REGEX.test(node.nodeValue)) textNodes.push(node);
    REF_REGEX.lastIndex = 0;
  }
  textNodes.forEach((tn) => {
    const replaced = linkifyText(tn.nodeValue);
    if (replaced === tn.nodeValue) return;
    const wrap = doc.createElement("span");
    wrap.innerHTML = replaced;
    tn.replaceWith(...Array.from(wrap.childNodes));
  });
  return root.innerHTML;
}
